(function(window) {
  const secondaryHero = document.querySelector('.secondary-hero');
  const secondaryHeroBottomTitle = document.querySelector('.has-title-below-banner');
  const secondaryHeroOverlay = document.querySelector('.secondary-hero-bottom--overlay');
  if(secondaryHero && secondaryHeroBottomTitle) {
    secondaryHero.classList.add('secondary-hero--bottom-heading');
    secondaryHero.classList.remove('secondary-hero--overlay');
    secondaryHero.classList.remove('secondary-hero---ada-overlay');
  }

  if(secondaryHeroOverlay) {
    secondaryHeroOverlay.style.opacity = secondaryHero.getAttribute('data-opacity');
  }
})(this)